import { render, staticRenderFns } from "./MonthCard.vue?vue&type=template&id=71857856&scoped=true&"
import script from "./MonthCard.vue?vue&type=script&lang=js&"
export * from "./MonthCard.vue?vue&type=script&lang=js&"
import style0 from "./MonthCard.vue?vue&type=style&index=0&id=71857856&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71857856",
  null
  
)

export default component.exports